import { APPROVED, ARCHIVED, EDITS_REQUESTED, Metadata, PENDING_REVIEW, READY_FOR_APPROVAL } from "models/SearchResult"

export const isPendingReview = (metadata: Metadata) => metadata.status === PENDING_REVIEW
export const isEditsRequested = (metadata: Metadata) => metadata.status === EDITS_REQUESTED
export const isApproved = (metadata: Metadata) => metadata.status === APPROVED
export const isReadyForApproval = (metadata: Metadata) => metadata.status === READY_FOR_APPROVAL
export const isArchived = (metadata: Metadata) => metadata.status === ARCHIVED